var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 80,
    viewBox: "0 0 276 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.821 67.5426H215.725V68.6393V78.1362H18.7735L1.09671 56.2079V1.09671H256.655L274.332 23.0249V78.1362H251.571L246.093 68.1133L245.781 67.5426H245.13H216.821Z",
    fill: "url(#paint0_radial_8914_14795)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.821 67.5426H215.725V68.6393V78.1362H18.7735L1.09671 56.2079V1.09671H256.655L274.332 23.0249V78.1362H251.571L246.093 68.1133L245.781 67.5426H245.13H216.821Z",
    fill: "url(#paint1_radial_8914_14795)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.821 67.5426H215.725V68.6393V78.1362H18.7735L1.09671 56.2079V1.09671H256.655L274.332 23.0249V78.1362H251.571L246.093 68.1133L245.781 67.5426H245.13H216.821Z",
    stroke: "url(#paint2_linear_8914_14795)",
    strokeWidth: 2.19342,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.712 74.3861L225.184 77.2371L228.172 75.3483V78.7298H229.644V73.0703L225.184 75.9001L220.712 73.0703V74.3861Z",
    fill: "#1FE4F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M230.165 78.652V78.7298H236.109V77.7818H231.648L230.165 78.652ZM230.165 73.0703L231.648 74.0183H236.109V73.0703H230.165ZM230.165 75.4332V76.374H231.648H236.109V75.4332H231.648H230.165Z",
    fill: "#1FE4F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.254 73.0703V74.0183V78.7298H238.749V74.0183H241.715V73.0703H237.254Z",
    fill: "#1FE4F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M243.233 76.848L244.549 75.1855L245.853 76.848H247.526L244.549 73.0703L240.088 78.7298H241.738L242.497 77.7818L243.233 76.848ZM248.262 77.7889H246.612L247.348 78.7298H249.009L248.262 77.7889Z",
    fill: "#1FE4F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8914_14795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.573 2.8105) rotate(90) scale(41.058 566.443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FE4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272421",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8914_14795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.186 78.9633) rotate(-90) scale(36.8058 247.141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FE4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272421",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8914_14795",
    x1: 137.714,
    y1: 79.2326,
    x2: 137.714,
    y2: 0.0000566715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FE4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AE6EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBg);
export default __webpack_public_path__ + "static/media/button-bg.555cd32aab205ae5e0e75eed90337060.svg";
export { ForwardRef as ReactComponent };